import * as THREE from "three";
import {Euler, Vector3, Mesh, RingGeometry} from "three";
import {clearGroup} from "../sceneManager";
import {setObjectPosition} from "./threeUtils";
import {mousePosition, tmpGroup} from "../main";
import {previewMaterial, lineMaterial} from "../constants/materialConstants";
import {Text} from "../models/baseElements/text";
import {Line} from "../models/baseElements/line";
import {toFixedFloat} from "./utils";

export function addCirclePointer(position, radius, group, layer, material) {
    let geometry = new THREE.CircleGeometry(radius, 16);
    geometry.rotateX(Math.PI / 2);
    let plane = new THREE.Mesh(geometry, material);
    setObjectPosition(plane, position);
    plane.layers.set(layer);
    group.addWithUuid(plane);
    return plane;
}

export function addDefaultCirclePointer(overwritePoint = null) {
    let position = new THREE.Vector3();
    overwritePoint === null ? position.copy(mousePosition) : position.copy(overwritePoint);
    return addCirclePointer(position, 0.075, tmpGroup, 0, previewMaterial);
}

export function addNumberedDefaultCirclePointer(overwritePoint = null, number) {
    let position = new THREE.Vector3();
    overwritePoint === null ? position.copy(mousePosition) : position.copy(overwritePoint);
    let circlePointer = addCirclePointer(position, 0.025, tmpGroup, 0, previewMaterial);
    circlePointer.addWithUuid(new Text(number.toString(), 0.1, "center", -0.1, new Vector3(0.05, 0, 0), new Euler(-Math.PI / 2, 0, 0), null, 0xff0000));
    return circlePointer;
}

export function addDefaultSquarePointer(position, sizeX, sizeZ) {
    clearGroup(tmpGroup);
    let geometry = new THREE.PlaneGeometry(sizeX, sizeZ);
    geometry.rotateX(Math.PI / 2);
    let plane = new THREE.Mesh(geometry, previewMaterial);
    setObjectPosition(plane, position);
    plane.layers.set(0);
    tmpGroup.addWithUuid(plane);
}

export function createHelpLines(points, group, helpLineLength=0.4, lineThickness=0.01, upwards=false) {
    for (let i = 0; i < points.length; i++) {
        let point = points[i];
        let shortHelpline = 0.5;
        let distanceNext = i < points.length ? Math.abs(toFixedFloat(points[i + 1] - point)) : null;
        let distancePrevious = i >= 1 ? Math.abs(toFixedFloat(points[i - 1] - point)) : null;

        if ((distanceNext !== null && distanceNext <= 0.1) || 
            (distancePrevious !== null && distancePrevious <= 0.1)) {
            shortHelpline = 0.25;
        }
        let lineLength = helpLineLength * shortHelpline;
        let line = new Line(
            new Vector3(point, 0, lineLength), 
            new Vector3(point, 0, -lineLength), 
            lineThickness
        );
        line.rotateY(Math.PI / 2);
        group.addWithUuid(line);
    }
}

export function createHelpLineCircles(points, group, helpLineCircleDiameter=0.05, circleLineThickness=0.01) {
    for (let i = 0; i < points.length; i++) {
        let point = points[i];
        let ringGeometry = new RingGeometry((helpLineCircleDiameter / 2) - circleLineThickness, helpLineCircleDiameter / 2);
        ringGeometry.rotateX(-Math.PI / 2);
        let ringMesh = new Mesh(ringGeometry, lineMaterial);
        ringMesh.position.x = point;
        group.addWithUuid(ringMesh);
    }
}

export function repositionPointer(pointer, position) {
    if (pointer === null || position === undefined) {
        return;
    }
    pointer.position.set(position.x, position.y, position.z);
}

export function recolorPointer(pointer, material) {
    if (pointer === null) {
        return;
    }
    pointer.material = material;
}
